export enum NavigationDirection {
  NEXT = "NEXT",
  PREVIOUS = "PREVIOUS",
}

export enum PickerType {
  RANGE = "RANGE",
  DAY = "DAY",
}
